import Card from "@mui/material/Card";
import { Grid, Typography, TextField } from '@mui/material';
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { toast } from 'react-toastify';
import { CircularProgress, Backdrop } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { handleErrors } from "common.js";
import { WITHDRAWAL } from 'constants.js';
import configurations from "config";

function WithdrawalView(props) {
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;
  const { t } = useTranslation();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [withdrawalData, setWithdrawalData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const data = (id) => {
    axios({
      url: baseUrl + "/withdrawal/view/" + id,
      method: "GET",
      headers: {
        Authorization: bearerToken,
        function: azureFunctionVendorFrontendKey
      },
    }).then(function (response) {
      setIsLoading(false)
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setWithdrawalData(response.data);
        }
        else {
          toast.error(t(message));
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate('/withdrawal/list/', { replace: true });
          }, 3000);
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
        const redirectTimeout = setTimeout(() => {
          clearTimeout(redirectTimeout);
          navigate('/withdrawal/list/', { replace: true });
        }, 3000);
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data(id);
  }, []);

  const getStatusText = (status) => {
    return status === WITHDRAWAL.COMPLETED ? t('Completed') : t('Pending');
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t('Withdrawal details')} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3} >
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {(withdrawalData.data) ?
                <MDBox component="form" role="form">
                  <Grid container spacing={2} mt={5} ml={2} mb={5}>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('id')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.id}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Total price')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.totalPrice}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Admin charge')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.adminCommission}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Vendor due')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.vendorAmount}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Shipping cost')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.shippingCost}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Return cost')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.returnCost}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('status')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{getStatusText(withdrawalData.data.status)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('transactionReferenceNumber')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.transactionId || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Remarks')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.remarks || '-'}</Typography>
                    </Grid>
                  </Grid>
                </MDBox>
                :
                null
              }
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default WithdrawalView;
